export default "__VITE_ASSET__CLMKutU7__"